"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplaceCarHeadsUpBannerWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var ReplaceCarHeadsUpBannerWidget = /** @class */ (function (_super) {
    __extends(ReplaceCarHeadsUpBannerWidget, _super);
    function ReplaceCarHeadsUpBannerWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            carToReplace: null
        };
        return _this;
    }
    ReplaceCarHeadsUpBannerWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getPolicy(this.props.engine.getInteraction().agreementNumber).subscribe(function (policy) {
            _this.setState({
                carToReplace: policy.insuredVehicles[0]
            });
        });
    };
    ReplaceCarHeadsUpBannerWidget.prototype.render = function () {
        var vehicleWording;
        if (this.state.carToReplace) {
            vehicleWording = "the " + this.state.carToReplace.make + " "
                + this.state.carToReplace.model + "(" + this.state.carToReplace.registrationNumber + ")";
        }
        else {
            vehicleWording = "your already covered vehicle";
        }
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { className: "text-group banner banner-info", children: (0, jsx_runtime_1.jsxs)("p", { className: "panel", children: ["Heads up - if you still need cover for ", vehicleWording, " then you need to add the replacement car\u00A0", (0, jsx_runtime_1.jsx)("a", { href: "/journey/show/product/MotorInsurance/process/mtaAddCar", children: (0, jsx_runtime_1.jsx)("b", { className: "text-decoration-underline text-blue-1", children: "here" }) })] }) }) }));
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], ReplaceCarHeadsUpBannerWidget.prototype, "customerPortalService", void 0);
    return ReplaceCarHeadsUpBannerWidget;
}(plugin_journey_1.WidgetBase));
exports.ReplaceCarHeadsUpBannerWidget = ReplaceCarHeadsUpBannerWidget;
//# sourceMappingURL=ReplaceCarHeadsUpBannerWidget.js.map